<div class="skeleton">
  <div class="skeleton__item">
    <div class="skeleton__item--status"></div>
    <div class="skeleton__item--location"></div>
    <div class="skeleton__item--date"></div>
  </div>
  <div class="skeleton__item">
    <div class="skeleton__item--status"></div>
    <div class="skeleton__item--location"></div>
    <div class="skeleton__item--date"></div>
  </div>
</div>
